import "./PassesSectionV2.scss";

interface IPassCard {
  title: string;
  subtitle?: string;
  validity?: string;
  price: string;
  priceLabel: string;
  renewPrice?: string;
  renewLabel?: string;
  featured?: boolean;
  badge?: string;
  icon: string;
}

const passes: IPassCard[] = [
  {
    title: "Wejście jednorazowe",
    price: "30 zł",
    priceLabel: "za wejście",
    icon: "single",
  },
  {
    title: "Karnet 10 wejść",
    validity: "Ważny: 60 dni",
    price: "159 zł",
    priceLabel: "za karnet",
    icon: "ten",
  },
  {
    title: "Karnet OPEN",
    price: "129 zł",
    priceLabel: "pierwszy raz",
    renewPrice: "119 zł",
    renewLabel: "kontynuacja",
    featured: true,
    badge: "Najpopularniejszy",
    icon: "open",
  },
  {
    title: "Karnet 0:00–13:00",
    validity: "Ważny: 30 dni",
    price: "109 zł",
    priceLabel: "pierwszy raz",
    renewPrice: "99 zł",
    renewLabel: "kontynuacja",
    icon: "night",
  },
  {
    title: "Karnet 3-miesięczny",
    price: "329 zł",
    priceLabel: "za 3 miesiące",
    icon: "quarterly",
  },
  {
    title: "Karnet roczny",
    price: "1199 zł",
    priceLabel: "za rok",
    badge: "Najlepsza wartość",
    icon: "annual",
  },
];

const iconPaths: Record<string, JSX.Element> = {
  single: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
        fill="currentColor"
      />
    </svg>
  ),
  ten: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"
        fill="currentColor"
      />
    </svg>
  ),
  open: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4l5 2.18V11c0 3.5-2.33 6.79-5 7.93-2.67-1.14-5-4.43-5-7.93V7.18L12 5z"
        fill="currentColor"
      />
    </svg>
  ),
  night: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"
        fill="currentColor"
      />
    </svg>
  ),
  quarterly: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
        fill="currentColor"
      />
    </svg>
  ),
  annual: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
        fill="currentColor"
      />
    </svg>
  ),
};

const PassesSectionV2 = () => {
  const navigateToPasses = () => {
    window.open(
      "https://centrumsily.gymmanager.io/public/buy-pass",
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <section className="pricingSection">
      <div className="pricingInner">
        {/* Header */}
        <div className="pricingHeader">
          <h2 className="pricingTitle">
            Wybierz swój
            <span className="pricingTitleRed"> karnet</span>
          </h2>
          <p className="pricingSubtitle">
            Elastyczne opcje dla każdego — od jednorazowego wejścia po roczny
            dostęp bez ograniczeń.
          </p>
        </div>

        {/* Cards grid */}
        <div className="pricingGrid">
          {passes.map((pass, i) => (
            <div
              key={i}
              className={`pricingCard${
                pass.featured ? " pricingCardFeatured" : ""
              }`}
              onClick={navigateToPasses}>
              {pass.badge && (
                <div className="pricingCardBadge">{pass.badge}</div>
              )}

              <div className="pricingCardTop">
                <div
                  className={`pricingCardIcon${
                    pass.featured ? " pricingCardIconFeatured" : ""
                  }`}>
                  {iconPaths[pass.icon]}
                </div>
                <div className="pricingCardTitle">{pass.title}</div>
                {pass.validity && (
                  <div className="pricingCardValidity">{pass.validity}</div>
                )}
              </div>

              <div className="pricingCardPrices">
                <div className="pricingCardPriceRow">
                  <span className="pricingCardPrice">{pass.price}</span>
                  <span className="pricingCardPriceLabel">
                    {pass.priceLabel}
                  </span>
                </div>
                {pass.renewPrice && (
                  <>
                    <div className="pricingCardDivider" />
                    <div className="pricingCardPriceRow pricingCardPriceRowRenew">
                      <span className="pricingCardPrice pricingCardPriceRenew">
                        {pass.renewPrice}
                      </span>
                      <span className="pricingCardPriceLabel">
                        {pass.renewLabel}
                      </span>
                    </div>
                  </>
                )}
              </div>

              <div className="pricingCardCta">
                Kup karnet <span className="pricingCardCtaArrow">→</span>
              </div>
            </div>
          ))}
        </div>

        {/* Footer note */}
        <div className="pricingFooter">
          <p className="pricingFooterNote">
            Ceny podane w złotych. Karnet jest aktywowany przy pierwszym
            wejściu.
          </p>
          <button className="pricingMainCta" onClick={navigateToPasses}>
            Przeglądaj wszystkie karnety
          </button>
        </div>
      </div>
    </section>
  );
};

export default PassesSectionV2;
